import React, { useEffect, useState } from "react";
import "./CategoryActions.css";
import pencil from "../../../../Assets/pencil.svg";
import trash from "../../../../Assets/trash.svg";
import MarkUnavailablePopup from "./MarkUnavailablePopup/MarkUnavailablePopup";
import EditCategoryPopup from "./EditCategoryPopup/EditCategoryPopup";
import DeletePopup from "./deleteallitems";
import { useDispatch } from "react-redux";
import {
  deleteCategory,
  markAllItemsUnavailable,
  removeMultipleItems,
  updateNewCategory,
} from "../../../../redux/Slice/OrderSlice";
import api from "../../../../services/api";
import { useToast } from "../../../../mesageToast/ToastContainer";
import { useNavigate } from "react-router-dom";
import { getAccessToken, getRestaurantName } from "../../../../auth/AuthHandler";

const CategoryActions = ({ activeCategory, items, onSelectCategory }) => {
  const [showUnavailablePopup, setShowUnavailablePopup] = useState(false);
  const [isSliderOn, setIsSliderOn] = useState(false);
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState(activeCategory);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const dispatch = useDispatch();
  const addToast = useToast();
  const navigate = useNavigate();

  const handleToggle = () => {
    setShowUnavailablePopup(true);
  };

  useEffect(() => {
    if (items.length === 0) {
      setIsSliderOn(false);
    } else {
      const allUnavailable = items.every((item) => !item.available);
      setIsSliderOn(allUnavailable);
    }
  }, [items]);

  const handleUnavailableItem = () => {
    const unavailableItems = items.map((item) => item._id);
    api
      .patch("/restaurant-management/updateToggleAvalablityCategory", {
        selectedItems: unavailableItems,
        available: isSliderOn,
      })
      .then(() => {
        addToast(
          "Items Updated",
          `All items in the ${activeCategory} have been marked as ${isSliderOn ? "Available" : "Unavailable"}.`,
          "success"
        );
        setShowUnavailablePopup(false);
        dispatch(markAllItemsUnavailable({ category: activeCategory, status: isSliderOn }));
        setIsSliderOn(!isSliderOn);
      });
  };

  const handleCancel = () => {
    setShowUnavailablePopup(false);
  };

  const handleEditClick = () => {
    setShowEditPopup(true);
  };

  const handleUpdateCategory = (newName) => {
    if (newName === activeCategory) {
      addToast("No updates made", `Category name remains the same.`, "success");
      return;
    }

    setNewCategoryName(newName);
    const accessToken = getAccessToken();
    const restaurantName = getRestaurantName();

    if (!accessToken || !restaurantName) {
      navigate("/", { replace: true });
      return;
    }

    const selectedItems = items.map((item) => item._id);
    api
      .patch("/restaurant-management/menu/updateCategory", {
        selectedArray: selectedItems,
        newName,
        oldName: activeCategory,
        restaurantName,
      })
      .then(() => {
        addToast("Category Updated", `Category ${activeCategory} updated to ${newName}.`, "success");
        dispatch(updateNewCategory({ oldName: activeCategory, newName, selectedItems }));
        onSelectCategory(newName);
      })
      .catch(() => {
        addToast("Error", "Failed to update category.", "error");
      });

    setShowEditPopup(false);
  };

  const handleDeleteClick = () => {
    setShowDeletePopup(true);
  };

  const handleDeleteItem = () => {
    const selectedItems = items.map((item) => item._id);
    const accessToken = getAccessToken();
    const restaurantName = getRestaurantName();

    if (!accessToken || !restaurantName) {
      navigate("/", { replace: true });
      return;
    }

    api
      .patch("/restaurant-management/menu/deleteCatagories", {
        selectedItems,
        deleteCatagories: activeCategory,
        restaurantName,
      })
      .then(() => {
        addToast("Items Deleted", `All items in ${activeCategory} have been deleted.`, "success");
        dispatch(removeMultipleItems(selectedItems));
        dispatch(deleteCategory({ category: activeCategory }));
        onSelectCategory("All");
        setShowDeletePopup(false);
      })
      .catch(() => {
        addToast("Error", "Failed to delete items.", "error");
      });
  };

  return (
    <div className="category-actions">
      <h3>{activeCategory}</h3>
      {activeCategory !== "All" && (
        <div className="actions">
          {items.length !== 0 && (
            <label className="toggle">
              <span>Mark Unavailable</span>
              <input type="checkbox" checked={isSliderOn} onChange={handleToggle} />
              <span className="slider"></span>
            </label>
          )}
          <button className="edit" title="Edit" onClick={handleEditClick}>
            <img src={pencil} alt="Edit" />
          </button>
          <button className="delete" title="Delete" onClick={handleDeleteClick}>
            <img src={trash} alt="Delete" />
          </button>
        </div>
      )}
      {showUnavailablePopup && (
        <MarkUnavailablePopup
          activeCategory={activeCategory}
          isSliderOn={isSliderOn}
          onConfirm={handleUnavailableItem}
          onCancel={handleCancel}
        />
      )}
      {showEditPopup && (
        <EditCategoryPopup
          activeCategory={activeCategory}
          onUpdate={handleUpdateCategory}
          onClose={() => setShowEditPopup(false)}
        />
      )}
      {showDeletePopup && (
        <DeletePopup
          activeCategoryName={activeCategory}
          onDelete={handleDeleteItem}
          onCancel={() => setShowDeletePopup(false)}
        />
      )}
    </div>
  );
};

export default CategoryActions;


